<script>
import appConfig from "@/app.config";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "لیست اطلاعات بازیکنان",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "لیست اطلاعات بازیکنان",
      items: [
        {
          text: "مدیریت لیگ ها",
        },
        {
          text: "لیست لیگ ها",
          to: { name: "leagues" },
        },
      ],
      pageOptions: [10, 25, 50, 100],
      fields: [
        {
          key: "rowIndex",
          sortable: false,
          label: "ردیف",
        },
      ],
      application: null,
      tableDetail: {
        data: [],
        currentPage: 1,
        perPage: 10,
        search: "",
        sortBy: "id",
        sortDesc: false,
        totalRows: 1,
      },
      record: null,
      selectedColumns: [],
    };
  },
  watch: {
    "tableDetail.sortBy"() {
      this.fetchData();
    },
    "tableDetail.sortDesc"() {
      this.fetchData();
    },
    "tableDetail.currentPage"() {
      this.fetchData();
    },
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    tableKey() {
      let tableKey = "";
      this.selectedColumns.forEach((item) => {
        tableKey += item.name;
      });
      return tableKey;
    },
  },
  mounted() {
    this.fetchRecord();
  },
  methods: {
    fetchRecord() {
      this.$axios.get(`applications/${this.id}`).then((res) => {
        this.record = res.data;
        const applicationData = [];
        this.record.application_data.forEach((item) => {
          if (item.name !== "id" && item.name !== "lId") {
            applicationData.push(item);
          }
        });
        this.record.application_data = applicationData;
      });
    },
    fetchData(exportExcel = false) {
      const columns = [];
      this.selectedColumns.forEach((item) => {
        columns.push(item.name);
      });
      const params = {
        page: this.tableDetail.currentPage,
        size: this.tableDetail.perPage,
        order_key:
          this.tableDetail.sortBy != ""
            ? this.tableDetail.sortBy
            : "created_at",
        order_by: this.tableDetail.sortDesc ? "desc" : "asc",
        columns,
      };
      const fields = [
        {
          key: "rowIndex",
          sortable: false,
          label: "ردیف",
        },
        {
          key: "playerId",
          sortable: false,
          label: "نام بازیکن",
        },
      ];

      for (let i = 0; i < columns.length; i++) {
        const field = {
          key: columns[i],
          sortable: true,
          label: columns[i],
        };

        if (i >= 1 && i < 6) {
          field.thClass = "d-none d-md-table-cell";
          field.tdClass = "d-none d-md-table-cell";
        }

        if (i >= 6 && i < 8) {
          field.thClass = "d-none d-lg-table-cell";
          field.tdClass = "d-none d-lg-table-cell";
        }

        if (i >= 8) {
          field.thClass = "d-none";
          field.tdClass = "d-none";
        }
        fields.push(field);
      }

      if (exportExcel == true) {
        params.export = true;
      }

      this.fields = fields;

      let route = `applications/${this.$route.params.id}/leader-board`;

      this.$axios
        .get(route, {
          params,
        })
        .then((res) => {
          if (exportExcel === true) {
            this.$swal.fire(
              "موفق!",
              `عملیات گرفتن خروجی با موفقیت آغاز گردید و نتیجه از طریق پیامک به شما ابلاغ خواهد شد`,
              "success"
            );
          } else {
            if (res.data.data) {
              this.tableDetail.data = res.data.data;
              this.tableDetail.totalRows = res.data.total;
            }
          }
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="record">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div
              class="row px-2 mt-4 justify-content-between align-items-center"
            >
              <div
                class="d-flex justify-content-between align-items-center w-100"
              >
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    نمایش&nbsp;
                    <b-form-select
                      v-model="tableDetail.perPage"
                      size="sm"
                      @change="fetchData"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;رکورد
                  </label>
                </div>
                <b-button @click="fetchData(true)" variant="success"
                  >خروجی اکسل</b-button
                >
              </div>
            </div>
            <div>
              <div class="col-12 px-0">
                <validation-select
                  @input="fetchData"
                  class="mt-4"
                  :options="record.application_data"
                  v-model="selectedColumns"
                  multiple
                  validation-field-name="فیلدهای مورد نظر"
                  option-value-key="id"
                  option-text-key="name"
                  label="فیلدهای مورد نظر"
                >
                </validation-select>
              </div>
            </div>
            <h4
              v-if="tableDetail.data.length === 0"
              class="my-4 mx-auto w-100 text-center"
            >
              دیتایی وجود ندارد
            </h4>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :key="tableKey"
                v-if="tableDetail.data.length > 0"
                :items="tableDetail.data"
                :fields="fields"
                responsive="sm"
                :per-page="0"
                :current-page="tableDetail.currentPage"
                :sort-by.sync="tableDetail.sortBy"
                :sort-desc.sync="tableDetail.sortDesc"
              >
                <template
                  v-for="field in selectedColumns"
                  v-slot:[`cell(${field.name})`]="data"
                >
                  {{ data.item[field.name] }}
                </template>
                <template #cell(playerId)="data">
                  {{
                    data.item.player ? data.item.player.nickname : "---------"
                  }}
                </template>
                <template #cell(rowIndex)="data">
                  <span
                    class="d-flex align-items-center justify-content-center"
                  >
                    <span>{{
                      tableDetail.perPage * (tableDetail.currentPage - 1) +
                        data.index +
                        1
                    }}</span>
                    <b-badge
                      variant="primary"
                      v-if="!data.item._showDetails"
                      style="cursor: pointer"
                      class="ml-2"
                      :class="{
                        'd-none': selectedColumns.length < 1,
                        'd-inline-block d-md-none':
                          selectedColumns.length >= 1 &&
                          selectedColumns.length <= 6,
                        'd-md-inline-block d-lg-none':
                          selectedColumns.length > 6 &&
                          selectedColumns.length <= 8,
                        'd-inline-block': selectedColumns.length > 8,
                      }"
                      @click="data.toggleDetails"
                    >
                      +
                    </b-badge>
                    <b-badge
                      variant="danger"
                      v-else
                      @click="data.toggleDetails"
                      class="ml-2"
                      style="cursor: pointer"
                      :class="{
                        'd-none': selectedColumns.length < 1,
                        'd-inline-block d-md-none':
                          selectedColumns.length >= 1 &&
                          selectedColumns.length <= 6,
                        'd-md-inline-block d-lg-none':
                          selectedColumns.length > 6 &&
                          selectedColumns.length <= 8,
                        'd-inline-block': selectedColumns.length > 8,
                      }"
                    >
                      -
                    </b-badge>
                  </span>
                </template>
                <template slot="row-details" slot-scope="data">
                  <div
                    class="d-flex flex-column align-items-start justify-content-start"
                  >
                    <span
                      v-for="(item, i) in selectedColumns"
                      :class="{
                        'd-none': i < 1,
                        'd-inline-block d-md-none': i >= 1 && i < 6,
                        'd-md-inline-block d-lg-none': i >= 6 && i < 8,
                        'd-inline-block': i >= 8,
                      }"
                      :key="item.id"
                      ><strong>{{ item.name }}: </strong>
                      <span v-if="item.name === 'playerId'">
                        {{
                          data.item.player
                            ? data.item.player.nickname
                            : "---------"
                        }}
                      </span>
                      <span v-else>{{ data.item[item.name] }}</span>
                    </span>
                  </div>
                </template>
              </b-table>
            </div>
            <div :key="tableKey" class="row mt-2">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="tableDetail.currentPage"
                      :total-rows="tableDetail.totalRows"
                      :per-page="tableDetail.perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
